import { render } from "./perfilForm.vue?vue&type=template&id=3e19126a&scoped=true"
import script from "./perfilForm.vue?vue&type=script&lang=js"
export * from "./perfilForm.vue?vue&type=script&lang=js"

import "./perfilForm.vue?vue&type=style&index=0&id=3e19126a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e19126a"]])

export default __exports__